export const blogPosts = [
  {
    id: 1,
    slug: 'saveti-za-pakovanje',
    title_sr: 'Saveti za pakovanje pre selidbe',
    title_en: 'Packing tips before your move',
    content_sr: 'Priprema je ključ uspešne selidbe. Počnite ranije, koristite kvalitetne kutije i obeležite svaku kutiju po prostoriji.',
    content_en: 'Preparation is key to a smooth move. Start early, use quality boxes, and label each box by room.',
    image: '/assets/images/moving1.jpg'
  },
  {
    id: 2,
    slug: 'kako-odabrati-agenciju',
    title_sr: 'Kako odabrati agenciju za selidbe',
    title_en: 'How to choose a moving company',
    content_sr: 'Pitajte za preporuke, proverite recenzije i tražite transparentne cene bez skrivenih troškova.',
    content_en: 'Ask for referrals, check reviews, and look for transparent, no-hidden-fees pricing.',
    image: '/assets/images/moving2.jpg'
  },
  {
    id: 3,
    slug: 'selidba-sa-decom',
    title_sr: 'Selidba sa decom: praktični saveti',
    title_en: 'Moving with kids: practical tips',
    content_sr: 'Uključite decu u proces pakovanja, objasnite promene i zadržite rutinu kad god je moguće.',
    content_en: 'Involve kids in packing, explain changes, and keep routines whenever possible.',
    image: '/assets/images/moving3.jpg'
  },
  {
    id: 4,
    slug: 'selidba-uz-minimum-stresa',
    title_sr: 'Selidba uz minimum stresa',
    title_en: 'A stress-minimized move',
    content_sr: 'Napravite plan, zadužite odgovorne osobe i pripremite potrebne materijale unapred.',
    content_en: 'Create a plan, delegate responsibilities, and prepare materials in advance.',
    image: '/assets/images/moving4.jpg'
  },
  {
    id: 5,
    slug: 'organizacija-dana-selidbe',
    title_sr: 'Organizacija dana selidbe',
    title_en: 'Organizing moving day',
    content_sr: 'Pripremite listu zadataka za dan selidbe i budite u kontaktu sa timom za selidbe.',
    content_en: 'Prepare a moving-day checklist and stay in touch with the moving crew.',
    image: '/assets/images/moving5.jpg'
  },
  {
    id: 6,
    slug: 'skladistenje-saveti',
    title_sr: 'Skladištenje: najbolji saveti',
    title_en: 'Best tips for storage',
    content_sr: 'Koristite palete, zaštitite osetljive predmete i obezbedite dobru ventilaciju.',
    content_en: 'Use pallets, protect fragile items, and ensure good ventilation.',
    image: '/assets/images/moving6.jpg'
  }
];

// How to add a new blog post (template):
// 1) Add a new object to the array with a unique numeric `id` and unique `slug`.
// 2) Provide both Serbian and English titles and content (title_sr, title_en, content_sr, content_en).
// 3) Put your image into public/assets/images and reference it as '/assets/images/your-image.jpg'.
// 4) The BlogListPage and BlogPostPage will pick it up automatically and handle pagination.
// Example:
// {
//   id: 7,
//   slug: 'novi-saveti-za-selidbu',
//   title_sr: 'Novi saveti za selidbu',
//   title_en: 'New moving tips',
//   content_sr: 'Kratak uvod na srpskom...',
//   content_en: 'Short intro in English...',
//   image: '/assets/images/moving6.jpg'
// }
